import React from 'react';
import { useTranslation } from '@hooks/useTranslation';
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import './CustomDateTimePicker.scss';

const CustomDateTimePicker = ({
    value,
    onChange,
    format,
    calendar,
    locale,
    disabled = false,
    placeholder,
    minDate = null,
    maxDate = null,
    showPreview = false,
    currentLanguage = 'en'
}) => {
    const { t } = useTranslation();

    const renderCustomInput = (value, openCalendar) => {
        return (
            <button
                type="button"
                onClick={openCalendar}
                disabled={disabled}
                className={`btn-date-picker ${value ? 'has-value' : ''}`}
            >
                <span className="btn-icon">🗓️</span>
                <span className="btn-text">
                    {value || placeholder}
                </span>
                <span className="btn-arrow">▼</span>
            </button>
        );
    };

    return (
        <div className="form-group compact-datetime">
            {showPreview && (
                <div className={`date-preview ${!value ? 'empty' : ''}`}>
                    {value ? (
                        t('borrowing.return_preview', 'Return expected: {date}', {
                            date: value.format(currentLanguage === 'fr' ? 'dddd DD/MM/YYYY à HH:mm' : 'dddd MM/DD/YYYY at HH:mm')
                        })
                    ) : (
                        t('borrowing.no_date_selected', 'No return date selected')
                    )}
                </div>
            )}

            <DatePicker
                value={value}
                onChange={onChange}
                format={format}
                calendar={calendar}
                locale={locale}
                plugins={[
                    <TimePicker
                        key="time-picker"
                        position="bottom"
                        hideSeconds
                        format="HH:mm"
                    />
                ]}
                disabled={disabled}
                calendarPosition="bottom-start"
                minDate={minDate}
                maxDate={maxDate}
                render={renderCustomInput}
            />
        </div>
    );
};

export default CustomDateTimePicker;
